<div class="d-flex min-vh-75 w-100 flex-column justify-content-center">
    <div class="">                    
        <p class="fw-semi-bold">(3 of 10) Diet and Exercise</p>
        <div class="progress" style="height:8px">
        <div class="progress-bar" role="progressbar" style="width: 30%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
    <div class="flex-grow-1 "></div>
    <div class="d-flex d-flex justify-content-center">

        <div class="assessment-block">
            
            <p class="question-header">How would you describe your current diet in terms of managing diabetes?</p>
            
            <div class="form-check ps-10 pe-10">
                <input [(ngModel)]="assessment.dietAndExerciseQ1" class="btn-check" id="q1" type="radio" name="question1" value="Healthy and balanced" (change)="onChange()"/>        
                <label class="btn btn-small btn-outline-secondary w-100" for="q1">Healthy and balanced</label>
            </div>

            <div class="form-check ps-10 pe-10">        
                <input [(ngModel)]="assessment.dietAndExerciseQ1" class="btn-check" id="q2" type="radio" name="question1" value="Somewhat balanced" (change)="onChange()"/>
                <label class="btn btn-outline-secondary w-100" for="q2">Somewhat balanced</label>
            </div>

            <div class="form-check ps-10 pe-10">        
                <input [(ngModel)]="assessment.dietAndExerciseQ1" class="btn-check" id="q3" type="radio" name="question1" value="Not balanced" (change)="onChange()"/>
                <label class="btn btn-outline-secondary w-100" for="q3">Not balanced</label>
            </div>


            <p class="question-header mt-6">Are you engaging in regular physical activity?</p>

            
            <div class="form-check ps-10 pe-10">
                <input [(ngModel)]="assessment.dietAndExerciseQ2" class="btn-check" id="q4" type="radio" name="question2" value="Yes, regularly" (change)="onChange()"/>        
                <label class="btn btn-outline-secondary w-100" for="q4">Yes, regularly</label>
            </div>
            <div class="form-check ps-10 pe-10">        
                <input [(ngModel)]="assessment.dietAndExerciseQ2" class="btn-check" id="q5" type="radio" name="question2" value="Occasionally" (change)="onChange()"/>
                <label class="btn btn-outline-secondary w-100" for="q5">Occasionally</label>
            </div>
            <div class="form-check ps-10 pe-10">        
                <input [(ngModel)]="assessment.dietAndExerciseQ2" class="btn-check" id="q6" type="radio" name="question2" value="Rarely or never" (change)="onChange()"/>
                <label class="btn btn-outline-secondary w-100" for="q6">Rarely or never</label>
            </div>

        </div>
    </div>
    <div class="p-2 flex-grow-1"></div>
    
    <div class="d-flex mb-2">
        <div class="me-auto p-2">
            <button class="btn btn-link" (click)="_prevButton()" type="submit">Prev</button>
        </div>
        <div class="p-2">
        <button class="btn btn-link" (click)="_nextButton()" type="submit">Skip</button>
        </div>
        <div class="p-2">
        <button class="btn btn-primary" (click)="_nextButton()" type="submit">Next</button>
        </div>
    </div>
</div>
